<template>
  <div>
    <b-modal
        :title="$t('Proxy settings')"
        v-model="show"
        dialog-class="trans-modal bg-app"
        no-close-on-backdrop>
      <template v-slot:modal-footer>
        <b-button variant="primary" :disabled="loading" @click="save()">
          <b-spinner small variant="light" class="mr-1" v-if="loading"/>
          {{ $t("Save") }}
        </b-button>
        <b-button @click="show = !show" :disabled="loading">{{ $t("Close") }}</b-button>
      </template>
      <form @submit.prevent="save()">
        <b-form-group :class="formData.on ? '' : 'mb-0'">
          <b-checkbox v-model="formData.on" :disabled="loading">{{ $t("Use proxy when connect to internet.") }}</b-checkbox>
        </b-form-group>
        <div v-if="formData.on">
          <b-form-group>
            <label>{{ $t("Protocol") }}</label>
            <b-form-input v-model="formData.protocol" :disabled="loading"/>
          </b-form-group>
          <b-form-group>
            <label>{{ $t("Server") }}</label>
            <b-form-input v-model="formData.host" :disabled="loading"/>
          </b-form-group>
          <b-form-group>
            <label>{{ $t("Port") }}</label>
            <b-form-input type="number" v-model="formData.port" :disabled="loading"/>
          </b-form-group>
          <b-form-group>
            <label>{{ $t("Username") }}</label>
            <b-form-input v-model="formData.username" :disabled="loading"/>
          </b-form-group>
          <b-form-group class="mb-0">
            <label>{{ $t("Password") }}</label>
            <b-form-input type="password" v-model="formData.password" :disabled="loading"/>
          </b-form-group>
        </div>
        <button class="d-none"></button>
      </form>
    </b-modal>
  </div>
</template>

<script>
import appHelper from "../helpers/app_helper";

export default {
  name: "ProxySettingsModal",
  data: function () {
    return {
      formData: {
        on: false,
        protocol: "https",
        host: "",
        port: 0,
        username: "",
        password: ""
      },
      show: false,
      loading: false
    }
  },
  methods: {
    open: async function () {
      this.formData = await appHelper.getSetting("proxySettings") || {
        on: false,
        protocol: "https",
        host: "",
        port: 0,
        username: "",
        password: ""
      };

      this.show = true;
    },
    save: async function () {
      this.loading = true;
      await appHelper.setSetting("proxySettings", this.formData);
      this.loading = false;
      this.show = false;
    }
  }
}
</script>

<style scoped>

</style>